import { safeSet } from "./safeStorage";

export const updateLocalStorageFilters = (tableSettingsName, tableParamRef) => {
  safeSet(tableSettingsName, tableParamRef);
};
